var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveTimeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SaveTime_icon_svg__a",
    d: "M0 0h23.686v4.487H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.676 4.487l-.846-1.68A26.074 26.074 0 0130.674 0c4.164 0 8.149.945 11.842 2.806l-.847 1.681a24.206 24.206 0 00-10.995-2.605 24.21 24.21 0 00-10.998 2.605",
    fill: "#BCC0C4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.83 55.513)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "SaveTime_icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SaveTime_icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.84 0l.846 1.68a26.074 26.074 0 01-11.844 2.807C7.678 4.487 3.693 3.542 0 1.681L.847 0a24.206 24.206 0 0010.995 2.605A24.21 24.21 0 0022.84 0",
    fill: "#BCC0C4",
    mask: "url(#SaveTime_icon_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.631 29.489c0 12.99-10.531 23.522-23.522 23.522-12.991 0-23.523-10.531-23.523-23.522 0-12.991 10.532-23.522 23.523-23.522 12.99 0 23.522 10.531 23.522 23.522",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.468 44.543C5.66 44.543 1 47.34 1 49.248v4.704c0 1.91 4.66 4.705 8.468 4.705s8.468-2.796 8.468-4.705v-4.704c0-1.91-4.66-4.705-8.468-4.705",
    fill: "#F4A27F"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M40.518 21.962l-9.41 9.409-5.645-5.646"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EE4900",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M31.109 13.494v2.822M47.104 29.489h-2.823M31.109 45.484v-2.823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.936 53.952v-4.704c0-1.91-4.66-4.705-8.468-4.705S1 47.34 1 49.248v4.704",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.468 33.252c-2.432 0-4.704 1.821-4.704 4.066v3.16c0 2.246 2.272 4.065 4.704 4.065s4.705-1.82 4.705-4.065v-3.16c0-2.245-2.273-4.066-4.705-4.066",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.468 33.252c-2.432 0-4.704 1.821-4.704 4.066v3.16c0 2.246 2.272 4.065 4.704 4.065s4.705-1.82 4.705-4.065v-3.16c0-2.245-2.273-4.066-4.705-4.066z",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.586 29.489c0-12.991 10.532-23.522 23.523-23.522 12.99 0 23.522 10.531 23.522 23.522 0 12.99-10.531 23.522-23.522 23.522-3.324 0-6.487-.69-9.354-1.932",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.29 29.489c0-10.393 8.426-18.818 18.819-18.818 10.393 0 18.818 8.425 18.818 18.818s-8.425 18.818-18.818 18.818c-4.238 0-8.147-1.4-11.293-3.764",
    stroke: "#BCC0C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
export default SvgSaveTimeIcon;